import gql from 'graphql-tag';

import conversationOriginFacetFragment from '../fragments/conversationOriginFacetFragment';
import dokkioLabelFacetFragment from '../fragments/dokkioLabelFacetFragment';
import dokkioTagFacetFragment from '../fragments/dokkioTagFacetFragment';
import integrationFacetFragment from '../fragments/integrationFacetFragment';
import integrationItemKindFacetFragment from '../fragments/integrationItemKindFacetFragment';
import lastModifiedByFacetFragment from '../fragments/lastModifiedByFacetFragment';
import parentIntegrationItemFacetFragment from '../fragments/parentIntegrationItemFacetFragment';
import webpageTypeFacetFragment from '../fragments/webpageTypeFacetFragment';

export const querySearchFacets = gql`
  query searchFacets(
    $q: String
    $searchResultTypes: [SearchResultType!]
    $dokkioClusterIDs: [DokkioID]
    $dokkioLabelIDs: [DokkioID]
    $dokkioTagIDs: [DokkioID!]
    $dokkioTagRanges: [DokkioTagRangeInput!]
    $integrationIDs: [DokkioID!]
    $integrationItemKinds: [IntegrationItemKind!]
    $integrationItemTypes: [IntegrationItemType!]
    $parentIntegrationItemIDs: [IntegrationItemInput!]
    $lastModifiedBys: [LastModifiedBy!]
    $name: String
    $nameLowercase: String
    $neuralCount: Int
    $fileContentMD5: String
    $webpageTypes: [WebpageType!]
    $conversationOrigins: [ConversationOrigin!]
    $suggestedDokkioTagName: String
  ) {
    searchFacets(
      q: $q
      searchResultTypes: $searchResultTypes
      dokkioClusterIDs: $dokkioClusterIDs
      dokkioLabelIDs: $dokkioLabelIDs
      dokkioTagIDs: $dokkioTagIDs
      dokkioTagRanges: $dokkioTagRanges
      integrationIDs: $integrationIDs
      integrationItemKinds: $integrationItemKinds
      integrationItemTypes: $integrationItemTypes
      parentIntegrationItemIDs: $parentIntegrationItemIDs
      lastModifiedBys: $lastModifiedBys
      name: $name
      nameLowercase: $nameLowercase
      neuralCount: $neuralCount
      fileContentMD5: $fileContentMD5
      webpageTypes: $webpageTypes
      conversationOrigins: $conversationOrigins
      suggestedDokkioTagName: $suggestedDokkioTagName
    ) {
      dokkioClass
      searchResultTypeFacets {
        dokkioClass
        count
        searchResultType
      }
      dokkioLabelFacets {
        ...dokkioLabelFacetFragment
      }
      dokkioTagFacets {
        ...dokkioTagFacetFragment
      }
      integrationFacets {
        ...integrationFacetFragment
      }
      integrationItemKindFacets {
        ...integrationItemKindFacetFragment
      }
      lastModifiedByFacets {
        ...lastModifiedByFacetFragment
      }
      parentIntegrationItemFacets {
        ...parentIntegrationItemFacetFragment
      }
      webpageTypeFacets {
        ...webpageTypeFacetFragment
      }
      conversationOriginFacets {
        ...conversationOriginFacetFragment
      }
    }
  }
  ${conversationOriginFacetFragment}
  ${dokkioLabelFacetFragment}
  ${dokkioTagFacetFragment}
  ${integrationFacetFragment}
  ${integrationItemKindFacetFragment}
  ${lastModifiedByFacetFragment}
  ${parentIntegrationItemFacetFragment}
  ${webpageTypeFacetFragment}
`;

export default querySearchFacets;
